import React from "react";

const ItemList = ({
  filteredData = [],
  isExpanded,
  handleBoxClick,
  getSizeName,
  getColorName,
  constantApi,
  loading, // ✅ new prop
}) => {
  console.log("select items is --------------", filteredData);

  return (
    <div
      className={`grid mt-4 transition-all duration-300 ${
        isExpanded
          ? "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4"
          : "grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2"
      }`}
    >
      {loading ? (
        // ✅ Show loader when fetching
        <div className="col-span-full flex flex-col items-center justify-center py-6">
          <div className="animate-spin rounded-full h-8 w-8 border-4 border-blue-500 border-t-transparent"></div>
          <p className="mt-3 text-gray-500">Loading items...</p>
        </div>
      ) : filteredData.length > 0 ? (
        // ✅ Show items
        filteredData.map((masterItem, masterIndex) => {
          const imageUrl = masterItem?.item_image
            ? `${constantApi.imageUrl}/itemsImage/${masterItem?.item_image}`
            : null;

          return (
            <div
              key={masterIndex}
              onClick={() => handleBoxClick(masterItem)}
              className={`border border-gray-300 rounded-lg cursor-pointer hover:shadow-lg transition bg-white flex flex-col justify-between
              ${isExpanded ? "w-40 h-48" : "w-40 h-60"}`}
            >
              {/* Image Section */}
              <div className="w-full h-32 rounded-t-lg bg-gray-100 flex items-center justify-center overflow-hidden">
                {imageUrl && (
                  <img
                    src={imageUrl}
                    alt={masterItem.item_name}
                    className="w-full h-full object-cover"
                  />
                )}
              </div>

              {/* Item Info */}
              <div className="px-2 py-1 flex flex-col gap-1 text-center">
                {masterItem.barcode && (
                  <div className="flex justify-center text-sm">
                    <span className="text-sm">Barcode-</span>
                    {masterItem.itemupc}
                  </div>
                )}

                <h4 className="text-sm font-semibold truncate text-gray-800 text-left">
                  {masterItem.item_name}
                </h4>

                <div className="flex justify-between items-center text-xs">
                  <p className="text-gray-600 flex gap-1">
                    <span className="font-medium text-gray-700">Size:</span>
                    <span>{getSizeName(masterItem.sizename)}</span>
                  </p>
                  <p className="text-gray-600 flex gap-1">
                    <span className="font-medium text-gray-700">Color:</span>
                    <span>{getColorName(masterItem.colorname)}</span>
                  </p>
                </div>
              </div>

              {/* Price Section */}
              <div className="bg-blue-500 text-white text-sm font-bold py-1 rounded-b-lg text-center">
                {masterItem.itemprice}
              </div>

              {/* Price Section */}
              {/* <div className="bg-blue-500 text-white text-sm font-bold py-1 rounded-b-lg text-center">
                {masterItem.batches && masterItem.batches.length > 0
                  ? // Show landed price of the first available batch (or choose logic as needed)
                    masterItem.batches.find(
                      (batch) => parseFloat(batch.current_in_stock) > 0
                    )?.price_data?.itemlanprice
                  : // || masterItem.itemprice
                    // : masterItem.itemprice
                    0}
              </div> */}

              {/* Price Section */}
              {/* Price Section */}
              {/* <div className="bg-blue-500 text-white text-sm font-bold py-1 rounded-b-lg text-center">
                {masterItem.batches && masterItem.batches.length > 0
                  ? masterItem.batches
                      .sort(
                        (a, b) =>
                          new Date(a.created_at).getTime() -
                          new Date(b.created_at).getTime()
                      )
                      .find((batch) => parseFloat(batch.current_in_stock) > 0)
                      ?.price_data?.itemlanprice || 0
                  : 0}
              </div> */}
            </div>
          );
        })
      ) : (
        // ✅ Show empty message if not loading and no data
        <div className="col-span-full text-center text-gray-500 py-4">
          <h4>No items available</h4>
        </div>
      )}
    </div>
  );
};

export default ItemList;
